import { createFileRoute } from "@tanstack/react-router";
import BillingPage from "src/components/app/BillingPage/BillingPage";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import DocLink from "src/components/docs/DocLink/DocLink";
import { preloadLazyModule } from "src/lib/LazyModules";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { organisationLoader } from "src/lib/ScopedLoaders";
import { hasUsageCharts } from "src/lib/UsageChartUtils";
import { getBillingPageData } from "src/server/functions/Portal";
import { useExtracted } from "#i18n";

export const Route = createFileRoute("/_authed/portal/org_{$orgKey}/billing")({
  // The usage charts' code (recharts) loads with the page's data when there's a chart to draw.
  loader: async (context) => {
    const result = await organisationLoader((orgId) => getBillingPageData({ data: orgId }))(
      context,
    );
    const series = result.data?.initialUsage?.series;
    if (result.status === "pending" || (series && hasUsageCharts(series))) {
      await preloadLazyModule("usageChart");
    }
    return result;
  },
  component: BillingRoutePage,
});

function BillingRoutePage() {
  const translateMessage = useExtracted();
  return (
    <PortalPage>
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{translateMessage("Usage and billing")}</PortalPage.Title>
          <PortalPage.Description>
            {translateMessage(
              "Usage and cost by project, usage limits, credit, spend controls, payment details and invoices for your organisation.",
            )}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="usage-limits" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        <DeferredLoaderData result={Route.useLoaderData()}>
          {(data) => (
            <BillingPage
              initialOverview={data?.initialOverview}
              initialUsage={data?.initialUsage}
            />
          )}
        </DeferredLoaderData>
      </PortalPage.Content>
    </PortalPage>
  );
}
